import { FC, useEffect, useMemo, useState } from 'react';
import { useFormContext } from 'react-hook-form';
// i18next
import { useTranslation } from 'react-i18next';
// Redux
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
import { appActions } from 'store/app/appSlice';
import { selectQuizFormMenuItem } from 'store/app/appSelectors';
// Components
import MenuItem from './MenuItem';

interface IMenuItem {
  value: string;
  label: string;
  icon: string;
}

const QuizMenu:FC = () => {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  const quizFormMenuItem = useAppSelector(selectQuizFormMenuItem);

  const [ menuItemErrors, setMenuItemErrors ] = useState<string[]>([]);

  const { formState:{ errors } } = useFormContext();

  const menuItems:IMenuItem[] = useMemo(() => {
    return [
      { value: 'main', label: t('labels.main'), icon: 'list' },
      { value: 'prizes', label: t('labels.prizes'), icon: 'cup' },
      { value: 'theme', label: t('labels.theme'), icon: 'theme' },
      { value: 'images', label: t('labels.images'), icon: 'images' },
      { value: 'callToAction', label: t('labels.callToAction'), icon: 'call_to_action' },
      { value: 'leaderboard', label: t('labels.leaderboard'), icon: 'medal' },
      { value: 'liveLeaderboard', label: t('labels.liveLeaderboard'), icon: 'medal' },
    ]
    // eslint-disable-next-line
  }, [t]);

  useEffect(() => {
    dispatch(appActions.setQuizFormMenuItem('main'));
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if ( Object.keys(errors) ){
      const nextErrors = [];
      if ( errors.name ){
        nextErrors.push('main');
      }
      if ( errors.primaryColor ){
        nextErrors.push('theme');
      }
      if ( errors.logoImage ){
        nextErrors.push('images');
      }
      if ( errors.publicLeaderboard?.textColor ){
        nextErrors.push('liveLeaderboard');
      }
      setMenuItemErrors(nextErrors);
    }
    // eslint-disable-next-line
  }, [Object.keys(errors).length]);

  return (
    <div className="flex flex-col flex-grow bg-content rounded-xl">
      {menuItems.map(menuItem => (
        <MenuItem
          key={`menu-item-${menuItem.value}`}
          menuItem={menuItem}
          active={quizFormMenuItem === menuItem.value}
          error={menuItemErrors.includes(menuItem.value)}
        />
      ))}
    </div>
  )
}

export default QuizMenu;
